import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { Order } from '../../classes/order';
import { CartService } from '../../services/cart.service';
import { CommonService } from '../../services/common.service';
import { Orderitems } from '../../classes/orderitems';
import { Cityinventory } from '../../classes/invcheck';
import { Cartitems2 } from '../../classes/cartitems';
import { MatSnackBar } from '@angular/material';
import { ProductsService } from '../../services/products.service';

@Component({
  selector: 'app-ordermain',
  templateUrl: './ordermain.component.html',
  styleUrls: ['./ordermain.component.css']
})
export class OrdermainComponent implements OnInit {
  ostatus: any;
  action: any;
  msg: any;
  cquantity = 0;
  p = 1;
  counterflagforcancell = 0;
  id: any;
  cityid = 1;
  cityinventory: Cityinventory[];
  oid: any;
  citems: number;
  counter: any;
  cindex: any;
  payable: number;
  quantity: any;
  flag = 0;
  tax: number;
  totaldiscount: number;
  discount: number;
  prodprice: number
  prodsku: any;
  prodname: string;
  pid: number;
  data2: Cartitems2[];
  city_id= 1;
  ppinventory: any[];
  stockflag: number;
  orderitem: Orderitems[];
  ordercountflag: number;
  userid: any;
  uid: any;
  uname: any;
  uemail: any;
  umobile: any;
  order: Order[];
  public loading = false;
  found = 1;
constructor(private router: Router, private cartService: CartService,
   private commonService: CommonService, private snackbar: MatSnackBar, private productService: ProductsService) {
    const udata = this.commonService.getUserDataLocally();
    this.uid = udata.uid;
    this.uname = udata.uname;
    this.uemail = udata.uemail;
    this.umobile = udata.umobile;
   }
  ngOnInit() {
    let raz = 0;
    const gd = localStorage.getItem('razorpay');
     const gjson = JSON.parse(gd);
     if (gjson != null) {
       raz = gjson.raz;
     }
     if (raz == 1) {
       this.reloadWindow();
     }
    this. getOrderStatus();
    this.getMyOrders();
  }
  reloadWindow() {
    localStorage.removeItem('razorpay');
    window.location.reload();
  }
  getOrderStatus() {
    this.cartService.getOrderStatus()
    .subscribe(
      (x) => {
        this.ostatus = x;
      });
  }
  getMyOrders() {
    this.loading = true;
    this.cartService.getMyOrder(this.uid)
    .subscribe(
      (order: Order[]) => {
        this.loading = false;
        this.order = order;
        if(this.order && this.order.length > 0){
          this.found = 1;
        } else {
          this.found = 0;
        }
      });
  }

  cancelOrder(id, orderid) {
    this.id = id;
    this.oid = orderid;
    this.loading = true;
    this.counterflagforcancell = 0;
    this.getCancelOrderitems();
  }
  getCancelOrderitems() {
    this.cartService.getOrderDetail(this.oid)
    .subscribe(
      (orderitem: Orderitems[]) => {
        this.orderitem = orderitem;
        this.counterflagforcancell = this.orderitem.length;
        this.getProductInventory()
      });
  }
getProductInventory() {
  for (let i = 0 ; i < this.orderitem.length; i++) {
    this.commonService.getInventoryDetails(this.orderitem[i].product_id, this.city_id)
    .subscribe(
      (x) => {
        const id = x[0].id;
        let astock = x[0].actualstock;
        const qty = this.orderitem[i].quantity;
        astock = astock + qty;
        const tstock = astock + x[0].virtualstock;
        if (tstock > 0) {
          this.updateInventoryWithStatus(id, astock, tstock)
        } else {
          this.updateInventoryWithoutStatus(id, astock, tstock)
        }
      });
    }
}
updateInventoryWithStatus(id, astock, tstock) {
  const status = 1;
  this.commonService.updateStockWithStatus(id, astock , tstock, status )
  .subscribe(
    (x) => {
      this.counterflagforcancell = this.counterflagforcancell - 1;
      if (this.counterflagforcancell === 0) {
        this.orderCancell();
      }
    });
}
updateInventoryWithoutStatus(id, astock, tstock) {
  this.commonService.updateStockWithoutStatus(id, astock , tstock)
  .subscribe(
    (x) => {
      this.counterflagforcancell = this.counterflagforcancell - 1;
      if (this.counterflagforcancell === 0) {
        this.orderCancell();
      }
    });
}
  orderCancell() {
    this.cartService.updateOrderStatus(this.id)
    .subscribe(
      (x) => {
       this.changeStatusinView();
       });
  }
  changeStatusinView() {
    for ( let i = 0; i < this.order.length; i++) {
        if (this.order[i].id === this.id) {
          this.order[i].status_id = 7;
        }
      }
      this.loading = false;
      this.msg = 'Order Cancell Successfully';
      this.openSnackBar();
    }
goForReorder(orderno) {
  this.loading = true;
  this.cquantity = 0;
  this.ordercountflag = 0;
  this.citems = 0;
  this.getusercartitems(orderno);
}

addToCartFromOrderItems() {
  for (let i = 0; i < this.orderitem.length; i++) {
    this.productService.getOrderitems(this.orderitem[i].sku, this.orderitem[i].product_name)
    .subscribe((x) => {
      this.addcart(this.orderitem[i].product_name, this.orderitem[i].sku,
        x[i].price, this.orderitem[i].product_id, this.orderitem[i].quantity, x[i].splprice);
    });

  }
}

getOrderdetail(ono) {
  this.cartService.getOrderDetail(ono)
  .subscribe(
    (x: Orderitems[]) => {
      this.orderitem = x;
      this.ordercountflag = this.orderitem.length;
      this.addToCartFromOrderItems();
 });
}
getusercartitems(orderno) {
  this.cartService.getUserCartItems(this.uid)
  .subscribe(
    (x: Cartitems2[]) => {
      this.data2 = x;
      this.getOrderdetail(orderno);
      }
    );
}

addcart(name: string, sku: string, price: number, id: number, qty, splprice) {
  this.pid = id;
  this.prodname = name;
  this.prodsku = sku;
  this.prodprice = price;
 // this.discount = 0;
 // this.totaldiscount = 0;
  if (splprice === 0) {
    this.discount = 0;
    this.totaldiscount = 0;
    this.payable = price;
  }else {
    this.discount =  price - splprice;
    this.totaldiscount = splprice;
    this.payable = splprice;
  }
  this.checkItems(this.prodsku);
  this.tax = 0 ;
  if (this.flag === 0) {
    this.quantity = qty;
    this.cquantity = this.cquantity + qty;
   // this.payable = price * this.quantity;
   this.payable = this.payable * this.quantity
    this.ordercountflag = this.ordercountflag - 1;
    this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice,
      this.discount , this.totaldiscount, this.quantity, this.payable, this.tax, this.uid, this.uname)
    .subscribe(
      (x: Cartitems2[]) => {
        this.checkAllFlags();
      });
  } else {
    this.quantity = this.data2[this.cindex].quantity + qty
    this.cquantity = this.cquantity + qty;
    this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount) * this.quantity;
    this.ordercountflag = this.ordercountflag - 1;
    this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity, this.payable)
    .subscribe(
      (x: Cartitems2[]) => {
        this.checkAllFlags();
      });

}
}

checkAllFlags() {
  if (this.ordercountflag === 0) {
    this.loading = false;
    this.test();
  }
}
checkItems(sku) {
  this.flag = 0;
      if (this.data2.length > 0) {
        for (let i = 0; i < this.data2.length; i++) {
          if (this.data2[i].sku === sku) {
            this.flag = 1;
            this.cindex = i;
          }
        }
      } else {
        this.flag = 0;
      }
  }

test() {
  this.cartService.totalcartitems.subscribe(totalcartitems => {
    this.citems = totalcartitems;
  });
  this.msg = 'Items added to cart.';
  this.openSnackBar();
  this.cartitemchange();
  /*this.presentToast("     Item Added To cart");*/
 }
 openSnackBar() {
  this.snackbar.open(this.msg , this.action, {
    duration: 4000,
  });
}

 cartitemchange() {
  this.citems = this.citems + this.cquantity;
this.cartService.changeTotalCartItems(this.citems);
this.goToCart();
}
goToCart() {
  this.router.navigate(['/store/cart'])
}
}


